import { OwlDateTimeIntl } from "ng-pick-datetime";
export class GermanIntl extends OwlDateTimeIntl {
    constructor() {
        super(...arguments);
        /** A label for the cancel button */
        this.cancelBtnLabel = 'Schliessen';
        /** A label for the set button */
        this.setBtnLabel = 'Bestätigen';
        /** A label for the range 'from' in picker info */
        this.rangeFromLabel = 'Von';
        /** A label for the range 'to' in picker info */
        this.rangeToLabel = 'Bis';
    }
}
